export class SyncDescriptor {
  constructor(ctor) {
    let staticArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let supportsDelayedInstantiation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    this.ctor = ctor;
    this.staticArguments = staticArguments;
    this.supportsDelayedInstantiation = supportsDelayedInstantiation;
  }
}